import { render, staticRenderFns } from "./AppNavCollapse.vue?vue&type=template&id=2fe1e116&scoped=true&"
import script from "./AppNavCollapse.vue?vue&type=script&lang=js&"
export * from "./AppNavCollapse.vue?vue&type=script&lang=js&"
import style0 from "./AppNavCollapse.vue?vue&type=style&index=0&id=2fe1e116&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe1e116",
  null
  
)

export default component.exports